/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Removedate1Inputs */

const en_removedate1 = /** @type {(inputs: Removedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove date`)
};

const de_removedate1 = /** @type {(inputs: Removedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin entfernen`)
};

/**
* | output |
* | --- |
* | "Remove date" |
*
* @param {Removedate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const removedate1 = /** @type {((inputs?: Removedate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Removedate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_removedate1(inputs)
	return de_removedate1(inputs)
});
export { removedate1 as "removeDate" }